// extracted by mini-css-extract-plugin
export default {"breadcrum":"Breadcrumb_breadcrum__ftw30","campaign-title":"Breadcrumb_campaign-title__6lCi0"};